export function callOptionalFc<T = void>(fn: Function | undefined): T {
    if (fn && typeof fn == 'function') {
        return fn()
    }
}
